import React from 'react'
import { BackButton, Bloc, Header, ProgressBar } from '../ImportAll'

export default function Vue17() {
    return (
        <div>
            <Header
                title="Vous possédez deja un crédit ou une offre de banque ?"
                subTitle="Que souhaitez vous faire ?"
            />
            <div className="Container">
                <div className="BackNavigationContainerLeft">
                    <BackButton targetView={0} />
                </div>
            </div>
            <div className="Container">
                <ProgressBar size={100} time={1} />
            </div>

            <div className="Container">
                <Bloc
                    key="key150"
                    selectable
                    targetView={18}
                    nbcolumn={1}
                    simpleDoubleWord
                    text1="Comparer"
                    text2="Evaluez une offre de crédit que vous avez deja reçue, nous vous dirons si nous pouvons obtenir un meilleur taux. "
                    gtm_id="e17-Comparer"
                />
                <Bloc
                    key="key151"
                    selectable
                    linked_data_id="prj_type"
                    linked_data_value="RENEGOCIATION"
                    targetView={3}
                    nbcolumn={1}
                    simpleDoubleWord
                    text1="Renégocier"
                    text2="Vous possédez déja un crédit, remplissez vos informations afin d'obtenir la meilleure renégociation possible !"
                    gtm_id="e17-Renégocier"
                />
            </div>
        </div>
    )
}
